<template>
  <div class="article-container">
    <!-- 返回按钮 -->
    <div class="back-button" @click="goBack">
      <van-icon name="arrow-left" size="20" />
    </div>

    <!-- 标题区域 -->
    <div class="article-header" v-if="article.title">
      <h1 class="title">{{ article.title }}</h1>
      <div class="meta">
        <span class="date">{{ article.createTime }}</span>
      </div>
    </div>

    <!-- 内容区域 -->
    <div class="article-content">
      <template v-if="article.content">
        <!-- Markdown 内容 -->
        <div class="markdown-body" v-html="renderedContent"></div>
      </template>
      <!-- 加载中状态 -->
      <div v-else-if="loading" class="loading">
        <van-loading type="spinner" color="#1989fa"/>
      </div>
      <!-- 无内容状态 -->
      <div v-else class="empty">
        暂无内容
      </div>
    </div>
  </div>
</template>

<script>
import ArticleDao from '@/h5/doucan/network/article'
import MarkdownIt from 'markdown-it'
import 'highlight.js/styles/github.css'
import { Icon, Loading } from 'vant'

export default {
  name: 'ArticleDetailPage',
  components: {
    'van-icon': Icon,
    'van-loading': Loading
  },
  data () {
    return {
      loading: true,
      article: {
        title: '',
        createTime: '',
        content: null
      },
      // 初始化 markdown-it 实例
      md: new MarkdownIt({
        html: true,
        linkify: true,
        typographer: true,
        breaks: true
      })
    }
  },
  computed: {
    // 渲染 Markdown 内容
    renderedContent () {
      return this.article.content ? this.md.render(this.article.content) : ''
    }
  },
  created () {
    this.fetchArticleDetail()
  },
  // 添加mounted钩子，确保组件挂载时滚动到顶部
  mounted () {
    window.scrollTo(0, 0)
  },
  // 监听路由变化
  watch: {
    $route: {
      handler () {
        window.scrollTo(0, 0)
      },
      immediate: true
    }
  },
  methods: {
    // 返回上一页方法
    goBack () {
      this.$router.back()
    },
    async fetchArticleDetail () {
      try {
        const id = this.$route.query.id
        if (!id) {
          this.$toast('参数错误')
          return
        }

        this.loading = true
        // 调用API获取文章详情
        const response = await ArticleDao.getArticleDetail(id)
        if (response && response.data) {
          this.article = response.data
          // 数据加载完成后，确保滚动到顶部
          this.$nextTick(() => {
            window.scrollTo(0, 0)
          })
        }
      } catch (error) {
        console.error('获取文章详情失败:', error)
        this.$toast('获取文章详情失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style>
/* 返回按钮样式 */
.back-button {
  position: fixed;
  top: 16px;
  left: 16px;
  width: 36px;
  height: 36px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 100;
  cursor: pointer;
}

/* Markdown 样式 */
.markdown-body {
  box-sizing: border-box;
  min-width: 200px;
  max-width: 980px;
  margin: 0 auto;
}

.markdown-body img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 1.5em auto;
  border-radius: 8px;
}

.markdown-body h1,
.markdown-body h2,
.markdown-body h3,
.markdown-body h4,
.markdown-body h5,
.markdown-body h6 {
  margin-top: 24px;
  margin-bottom: 16px;
  font-weight: 600;
  line-height: 1.25;
}

.markdown-body h1 {
  font-size: 2em;
  padding-bottom: 0.3em;
  border-bottom: 1px solid #eaecef;
}

.markdown-body h2 {
  font-size: 1.5em;
  padding-bottom: 0.3em;
  border-bottom: 1px solid #eaecef;
}

.markdown-body p {
  margin-top: 0;
  margin-bottom: 16px;
  line-height: 1.6;
  text-align: justify;
  font-size: 1.2em;
}

.markdown-body blockquote {
  padding: 0 1em;
  color: #6a737d;
  border-left: 0.25em solid #dfe2e5;
  margin: 0 0 16px 0;
}

.markdown-body ul,
.markdown-body ol {
  padding-left: 2em;
  margin-top: 0;
  margin-bottom: 16px;
}

.article-container {
  padding: 16px;
  padding-top: 60px; /* 增加顶部内边距，给返回按钮留出空间 */
  background-color: #ffffff;
  min-height: 100vh;
}

.article-header {
  margin-bottom: 24px;
}

.title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 12px;
  line-height: 1.4;
}

.meta {
  font-size: 14px;
  color: #999;
}

.loading {
  text-align: center;
  padding: 32px 0;
}

.empty {
  text-align: center;
  color: #999;
  padding: 32px 0;
}
</style>
